/**
 * Check if error is related to chunk loading
 */
export function isChunkLoadingError(error) {
  if (!error?.message) return false

  return (
    error.message.includes('Loading chunk') ||
    error.message.includes('Failed to fetch') ||
    error.message.includes('Loading CSS chunk') ||
    error.message.includes('ChunkLoadError') ||
    error.message.includes('is not a valid JavaScript MIME type') ||
    error.message.includes('Expected a JavaScript module script') ||
    error.message.includes('Unable to preload CSS')
  )
}
